import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'events-polyfill';
import 'formdata-polyfill';

/* array polyfills for IE support */
import 'core-js/features/array/find';
import 'core-js/features/array/find-index';
import 'core-js/features/array/includes';
import 'core-js/features/array/flat-map';
/* string polyfills for IE support */
import 'core-js/features/string/includes';
import 'core-js/features/string/ends-with';
import 'core-js/features/string/starts-with';
/* object polyfills for IE support */
import 'core-js/features/object/entries';
/* URL polyfills for IE support */
import 'core-js/features/url-search-params';

import 'regenerator-runtime/runtime';

import { ConnectedRouter } from 'connected-react-router';
import React from 'react';
import get from 'lodash/get';
import { hydrate } from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './../common/store/configureStore';
import { getSiteRoutes } from './../common/utils';
import LocaleContext from '../common/context/locale';

import { After } from '@datenpate/after';

// Fixes HMR by avoiding recreating the history instance
import history from './history';

const routes = getSiteRoutes().default;

// FIXME hydrate state.i18n from cookie
const store = configureStore(history, window.__PRELOADED_STATE__);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then(registration => {})
      .catch(registrationError => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

const prepareAndRun = async data => {
  const language = get(data, 'page.page.countrySite.language', 'en');
  const {
    locale: dateLocale
  } = await import(/* webpackChunkName: "locale-[request]" */ `../common/i18n/locales/${language}.js`);

  return hydrate(
    <Provider store={store}>
      <LocaleContext.Provider value={{ dateLocale }}>
        <ConnectedRouter history={history}>
          <After data={data} routes={routes} />
        </ConnectedRouter>
      </LocaleContext.Provider>
    </Provider>,
    document.getElementById('root')
  );
};

prepareAndRun(window.__SERVER_APP_STATE__);

if (module.hot) {
  module.hot.accept();
}
